export default "__VITE_PUBLIC_ASSET__87dc3bed__"